import React, { useEffect, useState } from 'react';

import { CONFIGS } from '../../utilities/Configs';
import { ConstructFetchBody, FormatDate, FormatNumber, UrlQueryParam } from '../../utilities/Helpers';
import { Location, LocationFaucet, LocationPart, LocationPartContainer, LocationPartGroup, UserSettings } from '../../utilities/Types';

import { Add as IconAdd, Settings as IconSettings } from '@material-ui/icons';

import { FaucetEdit } from './FaucetEdit';
import { PartAdd } from './PartAdd';
import { PartEdit } from './PartEdit';

import './Init.css';

const imageKegL = '../../images/keg-size-l.png';
const imageKegNone = '../../images/keg-size-none.png';
const imageKegS = '../../images/keg-size-s.png';

export const Init = () => {
	const [locations, setLocations] = useState<undefined | Array<Location>>(undefined);
	const [partGroups, setPartGroups] = useState<undefined | Array<LocationPartGroup>>(undefined);
	const [selectedFaucet, setSelectedFaucet] = useState<undefined | LocationFaucet>(undefined);
	const [selectedPart, setSelectedPart] = useState<undefined | LocationPart>(undefined);
	const [selectedPartContainer, setSelectedPartContainer] = useState<undefined | LocationPartContainer>(undefined);
	const [userSettings, setUserSettings] = useState<undefined | UserSettings>(undefined);
	
	useEffect(() => {
        fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.SETTINGS_GET, [UrlQueryParam('token'), UrlQueryParam('id')])).then(
            (_response) => _response.json()
        ).then(
            (_response) => setUserSettings(_response['result'].length > 0 ? _response.result[0] : undefined)
        ).catch(
            () => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
        );
    }, []);
	
	useEffect(() => {
        fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.PART_GROUPS_INVENTORIES_GET, [UrlQueryParam('token'), UrlQueryParam('id')])).then(
            (_response) => _response.json()
        ).then(
            (_response) => setPartGroups(_response['result'])
        ).catch(
            () => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
        );
    }, []);
	
	useEffect(() => {
        fetchLocations();
	}, []);
	
	const fetchLocations = () => {
		fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.LOCATIONS_GET, [UrlQueryParam('token'), UrlQueryParam('id')])).then(
            (_response) => _response.json()
        ).then(
            (_response) => setLocations(_response['result'])
        ).catch(
            () => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
        );
	};

	const updateKegSize = (faucet) => {
		if (faucet['kid'] === null) {
			const post1 = [
				UrlQueryParam('id'),
				-1,
				(faucet['bid'] || -1),
				faucet['fid'],
				'0001-01-01',
				'0001-01-01',
				'0001-01-01',
				1
			];
			
			fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.KEG_UPSERT, [...[UrlQueryParam('token')], ...post1])).then(
				(_response1) => _response1.json()
			).then(
				(_response1) => {
					if (_response1['error'] !== undefined) {
						alert('Error: ' + _response1['error']['message']);
					}
					else {
						const post2 = [
							UrlQueryParam('id'),
							faucet['fid'],
							(faucet['did'] || -1),
							(faucet['bid'] || -1),
							_response1['result']
						];
				
						fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.FAUCET_UPDATE, [...[UrlQueryParam('token')], ...post2])).then(
							(_response2) => _response2.json()
						).then(
							(_response2) => {
								if (_response2['error'] !== undefined) {
									alert('Error: ' + _response2['error']['message']);
								}
								else {
									fetchLocations();
								}
							}
						).catch(
							() => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
						);
					}
				}
			).catch(
				() => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
			);
		}
		else {
			const post = [
				UrlQueryParam('id'),
				faucet['kid'],
				(faucet['bid'] || -1),
				faucet['fid'],
				(faucet['kegborndate'] || '0001-01-01'),
				(faucet['expirationdate'] || '0001-01-01'),
				(faucet['tappeddate'] || '0001-01-01'),
				(faucet['keg_size'] === 'Small' ? 2 : 1)
			];
			
			fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.KEG_UPSERT, [...[UrlQueryParam('token')], ...post])).then(
				(_response) => _response.json()
			).then(
				(_response) => {
					if (_response['error'] !== undefined) {
						alert('Error: ' + _response['error']['message']);
					}
					else {
						fetchLocations();
					}
				}
			).catch(
				() => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
			);
		}
	};
	
	return (
		<div className="system">
			{
				(userSettings === undefined || locations === undefined) ? (
					<p>Loading...</p>
				) : (
					<>
						<div className="legend">
							<p className="legend-item blue">Stations</p>
							<p className="legend-item green">Towers</p>
							<p className="legend-item orange">Faucets</p>
						</div>
						{
							locations.map(
								(_location, _i) => (
									<div key={_i}>
										{
											false && (
												<>
													<p className="heading">Other Parts</p>
													<p className="subheading mute">Equipment not assigned to the SmartSystem</p>
												</>
											)
										}
										{
											_location['Equipment'].map(
												(_equipment, _j) => (
													<div key={_j}>
														<div className="row spread">
															<p className="title bold">{_equipment['Equipment Name']} ({FormatNumber(_equipment['Parts'].length)})</p>
															<div className="center">
																<IconAdd fontSize="medium" className="pointer" onClick={() => setSelectedPartContainer({ id: _equipment['Equipment ID'], type: 37 })} />
															</div>
														</div>
														{
															_equipment['Parts'].map(
																(_part, _k) => (
																	<div key={_k} className="strip white" onClick={() => setSelectedPart(_part)}>
																		<p className="title">{FormatNumber(_k + 1)}. {_part['Part Name']}</p>
																	</div>
																)
															)
														}
													</div>
												)
											)
										}
										{
											false && (
												<>
													<p className="heading">SmartSystem &amp; Parts</p>
													<p className="subheading mute">Equipment assigned to the SmartSystem</p>
												</>
											)
										}
										{
											_location['System'].map(
												(_system, _j) => (
													<div key={_j}>
														<div className="strip gray">
															<div className="column">
																<div className="row spread">
																	<div>
																		<p className="heading">{_system['name']}</p>
																		<p className="subheading mute">{_system['typename']} with {FormatNumber(_system['stations'].length)} Stations</p>
																	</div>
																	<div className="center">
																		<IconAdd fontSize="medium" className="pointer" onClick={() => setSelectedPartContainer({ id: _system['sysid'], type: 7 })} />
																	</div>
																</div>
																{
																	_system['parts'].map(
																		(_part, _k) => (
																			<div key={_k} className="strip gray pointer" onClick={() => setSelectedPart(_part)}>
																				<p className="title">{FormatNumber(_k + 1)}. {_part['Part Name']}</p>
																			</div>
																		)
																	)
																}
															</div>
														</div>
														{
															_system['stations'].map(
																(_station, _k) => (
																	<div key={_k}>
																		<div className="strip blue">
																			<div className="column">
																				<div className="row spread">
																					<div>
																						<p className="heading">{_station['name']}</p>
																						<p className="subheading mute">Station with {FormatNumber(_station['towers'].length)} Towers</p>
																					</div>
																					<div className="center">
																						<IconAdd fontSize="medium" className="pointer" onClick={() => setSelectedPartContainer({ id: _station['stid'], type: 8 })} />
																					</div>
																				</div>
																				{
																					_station['parts'].map(
																						(_part, _l) => (
																							<div key={_l} className="strip blue pointer" onClick={() => setSelectedPart(_part)}>
																								<p className="title">{FormatNumber(_l + 1)}. {_part['Part Name']}</p>
																							</div>
																						)
																					)
																				}
																			</div>
																		</div>
																		{
																			_station['towers'].map(
																				(_tower, _l) => (
																					<div key={_l}>
																						<div className="strip green">
																							<div className="column">
																								<div className="row spread">
																									<div>
																										<p className="heading">{_tower['name']}</p>
																										<p className="subheading mute">Tower with {FormatNumber(_tower['faucets'].length)} Faucets</p>
																									</div>
																									<div className="center">
																										<IconAdd fontSize="medium" className="pointer" onClick={() => setSelectedPartContainer({ id: _tower['tid'], type: 9 })} />
																									</div>
																								</div>
																								{
																									_tower['parts'].map(
																										(_part, _m) => (
																											<div key={_m} className="strip green pointer" onClick={() => setSelectedPart(_part)}>
																												<p className="title">{FormatNumber(_m + 1)}. {_part['Part Name']}</p>
																											</div>
																										)
																									)
																								}
																							</div>
																						</div>
																						{
																							_tower['faucets'].map(
																								(_faucet, _m) => (
																									<div key={_m} className="strip orange">
																										<div className="column">
																											<div className="row spread">
																												<div className={(userSettings['enable_kegs'] === true ? 'pointer' : '')} onClick={userSettings['enable_kegs'] === true ? () => setSelectedFaucet(_faucet) : undefined}>
																													{
																														_faucet['brand'].trim() === '' ? (
																															<p className="title mute">{FormatNumber(_m + 1)}. No name</p>
																														) : (
																															<p className="title">{FormatNumber(_m + 1)}. {_faucet['brand'].trim()}</p>
																														)
																													}
																													{
																														_faucet['distributor'].trim() !== '' && (
																															<p className="subtitle">{_faucet['distributor']}</p>
																														)
																													}
																													{
																														userSettings['enable_kegs'] === true && (
																															<p className="subtitle">{_faucet['keg']}</p>
																														)
																													}
																												</div>
																												<div className="row center">
																													{
																														_faucet['kegborndate'] !== null && (
																															<p className="subtitle">{FormatDate(new Date(_faucet['kegborndate']))}</p>
																														)
																													}
																													<img
																														src={
																															(() => {
																																switch(_faucet['keg_size']) {
																																	case 'Small':
																																		return imageKegS;

																																	case 'Large':
																																		return imageKegL;

																																	default:
																																		return imageKegNone;
																																}
																															})()
																														}
																														alt="Keg Size"
																														className={userSettings['enable_kegs'] === true ? 'pointer' : undefined}
																														onClick={userSettings['enable_kegs'] === true ? () => updateKegSize(_faucet) : undefined}
																													/>
																													<IconAdd fontSize="medium" className="pointer" onClick={() => setSelectedPartContainer({ id: _faucet['fid'], type: 10 })} />
																													<IconSettings fontSize="medium" className={_faucet['serviceable'] === false ? 'mute' : ''} />
																												</div>
																											</div>
																											{
																												_faucet['parts'].map(
																													(_part, _n) => (
																														<div key={_n} className="strip orange pointer" onClick={() => setSelectedPart(_part)}>
																															<p className="title">{FormatNumber(_n + 1)}. {_part['Part Name']}</p>
																														</div>
																													)
																												)
																											}
																										</div>
																									</div>
																								)
																							)
																						}
																					</div>
																				)
																			)
																		}
																	</div>
																)
															)
														}
													</div>
												)
											)
										}
									</div>
								)
							)
						}
						{
							partGroups !== undefined && (
								<>
									{
										selectedPartContainer !== undefined && (
											<PartAdd container={selectedPartContainer} partGroups={partGroups} onAdd={fetchLocations} onClose={() => setSelectedPartContainer(undefined)} />
										)
									}
									{
										selectedPart !== undefined && (
											<PartEdit part={selectedPart} partGroups={partGroups} onEdit={fetchLocations} onClose={() => setSelectedPart(undefined)} />
										)
									}
								</>
							)
						}
						{
							selectedFaucet !== undefined && (
								<FaucetEdit faucet={selectedFaucet} onEdit={fetchLocations} onDeleteKeg={fetchLocations} onClose={() => setSelectedFaucet(undefined)} />
							)
						}
					</>
				)
			}
		</div>
	);
};